const SplashScreen = () => {
  document.title = `Please wait... - ${process.env.REACT_APP_NAME}`;

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{
        fontFamily: "var(--font-primary)",
        background: "#f1f6ff",
      }}
    >
      {/* Spinner */}
      <div
        className="w-12 h-12 rounded-full border-4 border-t-transparent animate-spin mb-6"
        style={{
          borderColor: "rgba(var(--blue-rgb), 0.2)",
          borderTopColor: "var(--blue)",
        }}
      />

      <p
        className="text-lg font-semibold mb-1"
        style={{ color: "var(--dark-blue)" }}
      >
        Loading
      </p>
      <p className="text-sm" style={{ color: "var(--meta)" }}>
        Please wait while we get things ready
      </p>
    </div>
  );
};

export default SplashScreen;
